import React from 'react';
import { BrowserRouter, NavLink, Route, Switch, useLocation } from 'react-router-dom';
import { FiArchive, FiArrowUpRight, FiFileText } from 'react-icons/fi';
import Resume from './components/Resume/Resume.component';
import Projects from './components/Projects/Projects.component';
import ChessLounge from './components/Chess/ChessLounge';
import './styles/Status.css';
import './styles/Home.css';

function WorkInProgress() {
  return (
    <main className="work-page home-page page-width">
      <section className="home-hero" aria-labelledby="home-title">
        <p className="home-premise">The agents are supposed to be building this website.</p>
        <h1 id="home-title">They’re playing <em>chess</em> instead.</h1>
      </section>
      <ChessLounge />
    </main>
  );
}

function SiteHeader() {
  const { pathname } = useLocation();
  const home = pathname !== '/resume' && pathname !== '/projects';
  return home ? (
    <header className="home-header page-width">
      <nav className="available-links home-nav" aria-label="Main navigation">
        <NavLink className="home-nav-link home-nav-primary" to="/resume"><FiFileText className="home-nav-icon" aria-hidden="true" focusable="false" /><span className="home-nav-copy"><span className="home-nav-title">Resume</span><span className="home-nav-subtitle" aria-hidden="true">The current edition</span></span></NavLink>
        <NavLink className="home-nav-link" to="/projects"><FiArchive className="home-nav-icon" aria-hidden="true" focusable="false" /><span className="home-nav-copy"><span className="home-nav-title">Archived projects</span><span className="home-nav-subtitle" aria-hidden="true">Before the agents</span></span></NavLink>
        <a className="home-nav-link home-nav-linkedin" href="/linkedin"><FiArrowUpRight className="home-nav-icon" aria-hidden="true" focusable="false" /><span className="home-nav-copy"><span className="home-nav-title">LinkedIn</span><span className="home-nav-subtitle" aria-hidden="true">Say hello</span></span></a>
      </nav>
    </header>
  ) : (
    <header className="site-header page-width">
      <NavLink className="wordmark" to="/" exact aria-label="Aniket Hirpara home">Aniket Hirpara<span className="pink"> /</span></NavLink>
      <nav aria-label="Main navigation">
        <NavLink to="/resume" activeClassName="current">Resume</NavLink>
        <NavLink to="/projects" activeClassName="current">Archive</NavLink>
        <a href="/linkedin">LinkedIn <span aria-hidden="true">↗</span></a>
      </nav>
    </header>
  );
}

function App() {
  return (
    <BrowserRouter>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <SiteHeader />
      <div id="main-content" tabIndex="-1">
        <Switch>
          <Route path="/resume" exact component={Resume} />
          <Route path="/projects" exact component={Projects} />
          <Route component={WorkInProgress} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
